import { render, staticRenderFns } from "./PreviewRewards.vue?vue&type=template&id=60ac62b4"
import script from "./PreviewRewards.vue?vue&type=script&lang=js"
export * from "./PreviewRewards.vue?vue&type=script&lang=js"
import style0 from "./PreviewRewards.vue?vue&type=style&index=0&id=60ac62b4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports